import React, { useEffect, useState, createContext, useContext } from 'react';
export type Lang = 'en' | 'da';
interface LanguageContextType {
  lang: Lang;
  setLang: (lang: Lang) => void;
  t: (en: string, da: string) => string;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [lang, setLangState] = useState<Lang>('en');
  useEffect(() => {
    const saved = localStorage.getItem('snakker-lang') as Lang;
    if (saved === 'en' || saved === 'da') {
      setLangState(saved);
    }
  }, []);
  const setLang = (l: Lang) => {
    setLangState(l);
    localStorage.setItem('snakker-lang', l);
  };
  // Helper function to easily swap text based on current language
  const t = (en: string, da: string) => lang === 'da' ? da : en;
  return <LanguageContext.Provider value={{
    lang,
    setLang,
    t
  }} data-id="element-156">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}